export const stickyCheckoutCta = {
    name: "StickyCheckoutCta",
    variants: [
        ["Control", 5], // Control
        ["Test", 5], // Treatment
    ],
    controlVariant: "Control",
    apply: ({ assignVariant, clearVariant, isParticipatingInOtherTests }) => {
        var _a, _b, _c, _d, _e;
        if (Skubacz.configuration.environment === "systemtest") {
            return;
        }
        const validPlatform = ((_b = (_a = Skubacz.Device) === null || _a === void 0 ? void 0 : _a.screen) === null || _b === void 0 ? void 0 : _b.isExtraSmall()) ||
            ((_d = (_c = Skubacz.Device) === null || _c === void 0 ? void 0 : _c.screen) === null || _d === void 0 ? void 0 : _d.isSmall());
        const validTheme = ["new_vision", "fiesta", "vesspa"].includes(Skubacz.configuration.theme_name);
        const validPage = Skubacz.configuration.view_name === "checkout";
        const isInOtherTest = isParticipatingInOtherTests();
        if (validPlatform && validTheme && validPage && !isInOtherTest) {
            const variant = assignVariant();
            // Make a DOM changes to hide footer and add paddings/margins for sticky CTA
            if (variant === "Test") {
                // Remove footer element, only on the checkout page
                const footer = document.querySelector(".m-footer, .m-section--footer");
                if (footer) {
                    footer.remove();
                    const dockHeight = ((_e = document.querySelector(".m-dock__content")) === null || _e === void 0 ? void 0 : _e.clientHeight) || 85;
                    // Add padding to be sure that fixed footer does not overlap content
                    const container = document.querySelector("#main-content");
                    if (container) {
                        container.style.paddingBottom = `calc(${dockHeight}px + 1.6rem)`;
                    }
                    // Remove bottom margin from other checkout elements to avoid extra space
                    const checkoutElements = document.querySelectorAll(".m-checkout, #main-content .m-section");
                    checkoutElements.forEach((el) => {
                        el.style.marginBottom = `0px`;
                        el.style.paddingBottom = `0px`;
                    });
                }
            }
        }
        else {
            clearVariant();
        }
    },
};
